<template>
  <div class="quiz-steps" v-if="questionsToShow.length">
    <div id="slider">
      <transition-group mode="out-in" name="fade" tag="ul">
        <li
          v-for="(step, indexQuestion) in questionsToShow"
          :key="indexQuestion"
          v-if="indexQuestion === currentIndex">
          <div>
            <div class="quiz-step__title">{{ step.title }}</div>
            <div class="quiz-step-options">
              <div v-for="(option,indexAnswer) in step.options" :key="indexAnswer">
                <button @click="nextSlide(indexAnswer + 1)">
                  {{ option }}
                </button>
              </div>
            </div>
            <div class="quiz-step__link">
              <a :href="step.link">
                {{ step.textLink }}
              </a>
            </div>
          </div>
        </li>
        <li v-if="showAnswer" :key="questionsToShow.length">
          Answer
          <div v-if="productAnswerInfo">
            <img :src="productAnswerInfo.images[0]" width="200px" alt="Diva product">
            <div>{{ productAnswerInfo.title }}</div>
            <div>{{ productAnswerInfo.price }}</div>
            <button @click="goToProduct(productAnswerInfo.url)">View product</button>
          </div>

          <button @click="redoQuiz">Restart</button>
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>

/**
 * CSV file format:
 *  1st line: questions
 *  next lines: question, text link, link, option 1, option 2, ......
 *  next line: answers
 *  next lines: product-handle, answer option 1, answer option 2, ......
 */

import axios from "axios";

export default {
	selector: "#vue-quiz-diva",
  components: {
  },
  props: {
    file: { type: String }
  },
  data () {
    return {
      currentIndex: 0,
      active: 1,
      clientAnswer: [],
      showAnswer: false,
      productAnswerInfo: null,
      questionsToShow: [],
      answersToShow: [],
    }
  },
  mounted () {
    this.readCSVFile()
  },
  methods: {
    async readCSVFile() {
      if (this.file) {
        try {
          const fetchResponse = await fetch(this.file)
          const csvText = await fetchResponse.text()
          this.parseCSVFile(csvText)
        } catch (ex) {
          console.log('Error in readCSVFile',ex.message)
        }
      }
    },
    parseCSVFile (csvText) {
      csvText = csvText.replaceAll('\r', '')
      let lines = csvText.split('\n')

      const questionHeader = lines[0].split(',')
      if (questionHeader.length && questionHeader[0] == 'questions') {
        // get the questions
        lines.slice(1)
        for(let i = 1; i < lines.length; i++) {
          let aux = lines[i]
          const fields = aux[aux.length -1] == ',' ? aux.slice(0, -1).split(',') : aux.split(',')
          if (fields[0] === 'answers') {
            lines = lines.slice(i)
            break
          }
          this.questionsToShow.push({
            title: fields[0],
            textLink: fields[1],
            link: fields[2],
            options: fields.slice(3)
          })
        }

        // get the answers
        const answerHeader = lines[0].split(',')
        if (answerHeader.length && answerHeader[0] == 'answers') {
          lines.slice(1)
          for(let i = 1; i < lines.length; i++) {
            let aux = lines[i]
            const fields = aux[aux.length -1] == ',' ? aux.slice(0, -1).split(',') : aux.split(',')
            this.answersToShow.push({
              productHandle: fields[0],
              options: fields.slice(1).map(elem => Number(elem))
            })
          }
        }
      }
    },
    nextSlide (answer) {
      this.clientAnswer.push(answer)
      this.currentIndex++
      if (this.currentIndex === this.questionsToShow.length) {
        this.processAnswers()
        this.currentIndex = -1
      }
    },
    processAnswers () {
      this.answersToShow.forEach(answer => {
        if (JSON.stringify(answer.options) === JSON.stringify(this.clientAnswer)) {
          this.getProductInfo(answer.productHandle)
        }
      })
    },
    redoQuiz () {
      this.currentIndex = 0
      this.showAnswer = false
      this.clientAnswer = []
    },
    getProductInfo(productHandle) {
      axios.get(`/products/${productHandle}.js`)
        .then((response) => {
          this.productAnswerInfo = response.data
          this.showAnswer = true
        })
        .catch(error => {
          console.log(error)
        })
    },
    goToProduct (url) {
      document.location.href = url
    }
  }
}
</script>

<style lang="scss" scoped>
#slider {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  width: 100%;
  height: 100%;
}

#slider ul {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background: #ccc;
  list-style: none;
}

#slider ul li {
  position: relative;
  display: block;
  float: left;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  text-align: center;
}

.slider_option {
  position: relative;
  margin: 10px auto;
  width: 160px;
  font-size: 18px;
}

.quiz-steps {
  height: 100%;
}

.quiz-step-options {
  display: flex;
  justify-content: space-around;
  align-items: center;

}

button {
  background-color: black;
  color: white;
  padding: 20px;
  border-radius: 25%;
}

li {
  transition: all 1s;
}

.fade-enter-active, .fade-leave-active {
  transition: all 1s;
}
.fade-enter-to {
  transform: translateX(30px);
  opacity: 0;
}
.fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(-30px);
  opacity: 0;
}
</style>